<template>
  <QSelect
    v-model="sortBy"
    :label="label ? label : undefined"
    :options="options"
    option-label="label"
    option-value="value"
    outlined
    @input="handleSortBy"
    hide-dropdown-icon
    :disable="disabled"
    ref="sortSelection"
  >
    <template v-slot:prepend>
      <p style="font-size: 14px; margin: 0; padding: 0">{{ prependLabel }}</p>
    </template>
    <template v-slot:append>
      <QBtn flat dense @click.stop="handleSortOrder" size="xs">
        <FilterIcon v-model="sortedOrder" size="sm" color="grey-6" />
      </QBtn>
    </template>
  </QSelect>
</template>

<script>
import { QSelect, QBtn } from 'quasar';
import FilterIcon from './Icon/FilterIcon';

export default {
  props: {
    prependLabel: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sortOrder: {
      type: String,
      default: 'DESC'
    }
  },
  data() {
    return {
      sortBy: this.value,
      sortedOrder: this.isAscending(this.sortOrder),
      clickingSort: false
    };
  },
  methods: {
    handleSortBy() {
      this.$emit('onSortBy', this.sortBy);
    },
    handleSortOrder() {
      this.sortedOrder = !this.sortedOrder;
      this.$emit('onSortOrder', this.formatBooleanToSortOrder(this.sortedOrder));
    },
    isAscending(value) {
      return value.toUpperCase() === 'ASC';
    },
    formatBooleanToSortOrder(value) {
      return value ? 'ASC' : 'DESC';
    }
  },
  watch: {
    sortBy(value) {
      this.$emit('input', value);
    },
    value: {
      handler(v) {
        this.sortBy = v;
      },
      deep: true
    },
    sortOrder(v) {
      this.sortedOrder = this.isAscending(v);
    }
  },
  components: {
    QSelect,
    QBtn,
    FilterIcon
  }
};
</script>

<style scoped></style>
